import React from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import useSupportResourcesStore from 'graph/state/query-hooks/use-support-resources';
import ResourcesList from '@monorepo/shared/src/components/modules/Resources/ResourcesList';
import WithQuery from '@monorepo/shared/src/components/common/WithQuery';
import NoContent from '@monorepo/shared/src/components/common/NoContent';
import { AppRoutes } from 'types';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

const t = (key: string, options?) => translate('helpAndSupport', key, options);

const HelpAndSupportResources: React.FC = () => {
  const { supportResourceType } = useParams();
  const { resources, error, isLoading } = useSupportResourcesStore();
  const omitRoutes = useTrialUserOmitRoutes();
  const filteredResources = resources.filter((resource) =>
    resource.tags?.some((tag) => tag.value === supportResourceType)
  );

  return (
    <WithQuery loading={isLoading} error={error} ErrorComponent={NoContent}>
      <SectionHeader
        omitRoutes={omitRoutes}
        backRoute={`/${AppRoutes.HELP_AND_SUPPORT}`}
        title={t(supportResourceType ?? '')}
      />
      <Box paddingX={24}>
        <ResourcesList resources={filteredResources} areDisplayingCardHeaders={false} />
      </Box>
    </WithQuery>
  );
};

export default HelpAndSupportResources;
